import { render, staticRenderFns } from "./CreateClubModal.vue?vue&type=template&id=97b93c10&scoped=true&"
import script from "./CreateClubModal.vue?vue&type=script&lang=ts&"
export * from "./CreateClubModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateClubModal.vue?vue&type=style&index=0&id=97b93c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b93c10",
  null
  
)

export default component.exports